export default class ArticleForm {
  CatalogCode: number
  ArticleId: number
  UserId: number
  Form: Record<string, any>
  Type: 'editArticle' | 'modelDetails'

  constructor(articleForm: ArticleForm) {
    this.CatalogCode = articleForm.CatalogCode
    this.ArticleId = articleForm.ArticleId
    this.UserId = articleForm.UserId
    this.Form = articleForm.Form
    this.Type = articleForm.Type
  }
}
